import base from './base';

export default Object.assign(base, {
  api: {
    //toggle between the environment you want to use by commenting the url
    // root: 'https://backend.senzodata.com/api'
    //root: 'https://backend-dev.senzodata.com/api'
    root : "/api"
    // local: 'http://localhost/api'
  },
  livefeed: {
    // root: 'https://livefeed.senzolive.com'
    root: 'https://devlivefeed.senzolive.com'
  }
});



// WEBPACK FOOTER //
// ./src/config/production.js